export default {
  SD: 0.5,
  HD: 0.66667,
  FULL_HD: 1,
  UHD: 2
};
